import React from 'react';
import styles from './Sidebar.module.css';

function Sidebar({
  visible = true,
  menuItems = [],
  activeKey,
  onMenuClick,
  collapsed = false,
  onToggle
}) {
  if (!visible) return null;

  const renderBadge = (badge) => {
    if (!badge) return null;

    if (badge === true) {
      return <span className={`${styles.badge} ${styles.dotBadge}`} />;
    }

    return <span className={styles.badge}>{badge}</span>;
  };

  return (
    <div className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        <button className={styles.sidebarToggleBtn} onClick={onToggle}>
          {collapsed ? '→' : '←'}
        </button>
      </div>

      <div className={styles.sidebarMenu}>
        {menuItems.map(item => {
          const isActive = activeKey === item.key;
          // 选中用 icon，未选中优先用 unselectedIcon，没有再回退到 icon
          const currentIcon = isActive
            ? item.icon
            : (item.unselectedIcon || item.icon);

          return (
            <div
              key={item.key}
              className={`${styles.sidebarItem} ${isActive ? styles.active : ''}`}
              onClick={() => onMenuClick?.(item)}
              title={collapsed ? item.label : ''}
            >
              <span className={styles.sidebarItemIconWrapper}>
                <span className={styles.sidebarItemIcon}>
                  {currentIcon?.startsWith('#') ? (
                    <svg className={styles.sidebarSvgIcon} aria-hidden="true">
                      <use xlinkHref={currentIcon}></use>
                    </svg>
                  ) : (
                    currentIcon || '•'
                  )}
                </span>
                {renderBadge(item.badge)}
              </span>

              {!collapsed && (
                <span className={styles.sidebarItemLabel}>{item.label}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Sidebar;